import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {
  ServiceEventTicketPolicy,
  ServiceEventTicketPolicyEntity
} from "../../../model/service/service-event-ticket-policy";

export interface ServiceEventTicketPolicySelectorProps {
  regionId?: string;
}

const getRegionIdParam = createParamSelector<ServiceEventTicketPolicySelectorProps | undefined, string | undefined>(params => params?.regionId);

export const serviceEventTicketPoliciesSelector = () => createSelector(
  [getUseQueryResultData<ServiceEventTicketPolicy[]>, getRegionIdParam],
  (data, regionId) => {
    return selectServiceEventTicketPoliciesAndTransform(
      data ?? [], {
        regionId: regionId,
      }
    );
  }
);

export const serviceEventTicketPolicySelector = () => createSelector(
  [getUseQueryResultData<ServiceEventTicketPolicy>],
  (data) => {
    return data ? transformServiceEventTicketPolicy(data) : undefined;
  }
);

export const selectServiceEventTicketPolicies = (values?: ServiceEventTicketPolicy[], selector?: ServiceEventTicketPolicySelectorProps): ServiceEventTicketPolicy[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    if (selector?.regionId) {
      if (v.regionId !== selector.regionId) {
        filterIn = false;
      }
    }

    return filterIn;
  });
};

export const transformServiceEventTicketPolicy = (value: ServiceEventTicketPolicy): ServiceEventTicketPolicyEntity => {
  return ServiceEventTicketPolicyEntity.from(value)
}

export const selectServiceEventTicketPoliciesAndTransform = (values?: ServiceEventTicketPolicy[], selector?: ServiceEventTicketPolicySelectorProps): ServiceEventTicketPolicyEntity[] => {
  const selected = selectServiceEventTicketPolicies(values, selector);
  return selected.map(transformServiceEventTicketPolicy);
};
